/* eslint-disable */
import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import IReviewPage from "./ReviewPage";
import { offlineSBM, declarationDefault } from "../../../../store";
import { Dartboard } from "../../../../assets/Icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import DeclarationModal from "../../../review/DeclarationDetailModal";
import Button from "../../../../components/ui/Button";

export const PaymentOverview: FunctionComponent<IReviewPage.PaymentOverviewProps> = ({
  handleClick,
  errorMessage,
  setIsModalOpen,
  referrer,
  signA2FormStatus,
  handleSignA2Form,
  eSign,
  signLater,
  linkSent,
  setReferrer,
  isLoading,
  vendorCodes,
}) => {
  const [inputValue, setInputValue] = React.useState("");
  const offlineSbmData: any = useRecoilValue(offlineSBM);
  const [defaultDeclaration, setDefaultDeclaration] = useRecoilState(declarationDefault);

  const [isCheckedTermsAndCondition, setIsCheckedTermsAndCondition] =
    React.useState<boolean>(false);

  const [disableButton, setDisableButton] = React.useState<boolean>(true);
  const [showDeclaration, setShowDeclaration] = React.useState<boolean>(false);
  const [declaration, setDeclarationy] = React.useState<boolean>(false);
  const declarationModalRef = React.useRef<IDeclarationModal.IDeclarationModalHandles>(null);

  const handleTermsAndCondition = () => {
    setIsCheckedTermsAndCondition(!isCheckedTermsAndCondition);
  };

  const handleClearModalState = () => {
    declarationModalRef.current?.clearState();
  };

  React.useEffect(() => {
    setDisableButton(!Boolean(isCheckedTermsAndCondition && declaration));
  });

  React.useEffect(() => {
    setDefaultDeclaration({
      vendorCode: "select",
      branchName: "select",
      lanNumber: null,
      dualTransaction: false,
      dualTransactionNumber: null,
      docSufficient: null,
      takeCover: null,
      paymentUtr: null,
      salesUniqueKey: null,
      transferType: null,
    });
    handleClearModalState();
  }, [declarationModalRef]);
  const buttonStyle = {
    fontFamily: "font-roboto",
    fontSize: "text-base",
    fontWeight: "font-bold",
    fontColor: "text-white",
  };

  return (
    <div className="flex justify-center flex-col p-5 mt-0 space-y-10">
      <div id="purpose" className="flex items-center space-x-4">
        <div className="flex jus-center">
          <div className="">
            <Dartboard />
          </div>
          <div className="float-left ml-3 font-semibold">Purpose of Payment</div>
        </div>
        <div>
          <div className="flex font-bold text-gray-400 w-[250px] h-[30px] float-right">
            {offlineSbmData.transaction_purpose}
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="float-left mr-4 font-semibold">A2 Status :</div>
        {!linkSent && !eSign && !signLater && (
          <span className="text-red-600  font-bold"> {"( Not Signed )"} </span>
        )}
        {eSign ? <span className="text-green-600 font-bold"> {"( Signed )"} </span> : null}
        {linkSent && !eSign ? (
          <span className="text-red-600  font-bold"> {"( Link Sent )"} </span>
        ) : null}
        {!linkSent && !eSign && signLater ? (
          <h1 className="flex font-bold">
            <span className="text-red-600 mr-2">A2 form not signed</span>
            <span onClick={handleSignA2Form} className="text-primary cursor-pointer">
              ( Sign Now )
            </span>
          </h1>
        ) : null}
      </div>
      {((!eSign && signLater) || eSign || linkSent) && (
        <div className="flex flex-col">
          <div id="DTInput" className="mt-5 mb-16">
            <Button
              bgColor="bg-primary"
              onClickHandler={() => setShowDeclaration(true)}
              fontStyle={buttonStyle}
              className="px-6 py-2 w-42 font-bold transition-all rounded-md a2-download-button hover:bg-primary-150 hover:scale-105"
            >
              Declarations*
            </Button>
          </div>
          <form onSubmit={handleClick}>
            <div className="flex">
              <input
                type="checkbox"
                checked={isCheckedTermsAndCondition}
                onChange={handleTermsAndCondition}
                required
                className="review-checkbox"
              />

              <label className="ml-2 font-medium font-sans text-[18px] flex">
                <span>I agree to the </span>
                <span
                  className="ml-2 text-blue-500 cursor-pointer hover:underline"
                  onClick={() => setIsModalOpen("tnc")}
                >
                  {" Terms & Conditions."}
                </span>
              </label>
            </div>

            <input
              onClick={handleClick}
              name="review-pay-button"
              type={"submit"}
              className={clsx(
                disableButton
                  ? "review-pay-button mt-20 m-auto w-[250px] ml-36 h-[50px] bg-gray-200 rounded-[150px] cursor-pointer text-black text-[20px] font-bold"
                  : "review-pay-button mt-20 m-auto w-[250px] ml-36 h-[50px] bg-primary-200 rounded-[150px] cursor-pointer text-white text-[20px] font-bold hover:scale-105 hover:bg-red-200 transition-all",
              )}
              value={"PAY"}
              disabled={disableButton}
            />
            <span>{errorMessage}</span>
          </form>
        </div>
      )}
      {!eSign && !signLater && !linkSent && (
        <div className="flex justify-center w-full rounded-lg">
          <div className="flex items-center w-1/3 h-full rounded-lg justify-evenly bg-primary">
            <input
              type={"submit"}
              onClick={handleSignA2Form}
              className="py-3 font-bold text-white rounded-lg cursor-pointer justify-center bg-primary text-[18px]"
              value={`Sign A2 Form`}
            />
          </div>
        </div>
      )}
      <DeclarationModal
        isDeclarationModal={showDeclaration}
        setDeclarationModal={setShowDeclaration}
        enableDelcaration={setDeclarationy}
        type="offline"
        ref={declarationModalRef}
      />
    </div>
  );
};
